(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sfaq]').forEach((root) => {
    const items = Array.from(root.querySelectorAll('[data-sfaq-item]'));
    const filters = Array.from(root.querySelectorAll('[data-sfaq-filter]'));
    const search = root.querySelector('[data-sfaq-search]');
    const empty = root.querySelector('[data-sfaq-empty]');
    let activeCategory = 'all';

    const update = () => {
      const term = search ? search.value.trim().toLowerCase() : '';
      let visibleCount = 0;

      items.forEach((item) => {
        const categoryMatch = activeCategory === 'all' || item.dataset.category === activeCategory;
        const textMatch = term === '' || item.textContent.toLowerCase().includes(term);
        const visible = categoryMatch && textMatch;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (empty) empty.hidden = visibleCount !== 0;
    };

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeCategory = filter.dataset.sfaqFilter;
        filters.forEach((button) => {
          const active = button === filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        update();
      });
    });

    if (search) search.addEventListener('input', update);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sootheory-ritual-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.srf[data-section-id]');
    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const panels = [...root.querySelectorAll('[data-panel]')];
      const dots = [...root.querySelectorAll('.srf__progress-track span')];
      const currentLabel = root.querySelector('[data-current-step]');
      const dogInput = root.querySelector('[name="dog_name"]');
      const form = root.querySelector('.srf__form');
      let current = 1;
      let recommendation = 'oatmeal';
      let recommendedProducts = ['oatmeal'];

      const money = (cents) => {
        if (!cents) return '—';
        const currency = window.Shopify?.currency?.active || 'USD';
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency
        }).format(cents / 100);
      };

      const dogName = () => dogInput.value.trim() || 'Your dog';

      const updateNameTemplates = () => {
        root.querySelectorAll('[data-name-template]').forEach((el) => {
          el.textContent = el.dataset.nameTemplate.replace('[Dog’s name]', dogName());
        });
      };

      const showPanel = (number) => {
        current = number;
        panels.forEach((panel) => {
          const active = Number(panel.dataset.panel) === number;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index + 1 === number);
          dot.classList.toggle('is-complete', index + 1 < number);
        });
        currentLabel.textContent = number;
        updateNameTemplates();
        const activePanel = root.querySelector(`[data-panel="${number}"]`);
        activePanel?.querySelector('h1, h2, input, button')?.focus({ preventScroll: true });
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const getRitualRecommendation = () => {
        const coat = new FormData(form).get('coat');
        const details = new FormData(form).getAll('details');
        const scores = { oatmeal: 0, forest: 0, charcoal: 0 };
        const selected = new Set();
        const coatMatch = {
          sensitive: 'oatmeal',
          balanced: 'forest',
          oily: 'charcoal'
        }[coat] || 'oatmeal';

        selected.add(coatMatch);
        scores[coatMatch] += 4;

        const detailMatches = {
          outdoor: { product: 'forest', score: 3 },
          odor: { product: 'charcoal', score: 3 },
          oil: { product: 'charcoal', score: 3 },
          dry: { product: 'oatmeal', score: 3 },
          folds: { product: 'charcoal', score: 2 },
          gentle: { product: 'oatmeal', score: 2 }
        };

        details.forEach((detail) => {
          const match = detailMatches[detail];
          if (!match) return;
          selected.add(match.product);
          scores[match.product] += match.score;
        });

        const productOrder = ['oatmeal', 'forest', 'charcoal'];
        const primary = [...productOrder].sort((a, b) => {
          const scoreDifference = scores[b] - scores[a];
          if (scoreDifference !== 0) return scoreDifference;
          if (a === coatMatch) return -1;
          if (b === coatMatch) return 1;
          return productOrder.indexOf(a) - productOrder.indexOf(b);
        })[0];

        return {
          primary,
          selected: productOrder.filter((key) => selected.has(key)),
          scores
        };
      };

      const syncSelectionState = () => {
        root.querySelectorAll('.srf__choice, .srf__detail-choice, .srf__product, .srf__accessory').forEach((card) => {
          card.classList.toggle('is-selected', Boolean(card.querySelector('input')?.checked));
        });
      };

      const setupResults = () => {
        const ritual = getRitualRecommendation();
        recommendation = ritual.primary;
        recommendedProducts = ritual.selected;
        const recommendedCard = root.querySelector(`[data-product-key="${recommendation}"]`);
        root.querySelectorAll('.srf__product').forEach((card) => {
          card.classList.toggle('is-recommended', card === recommendedCard);
          card.querySelector('input').checked = recommendedProducts.includes(card.dataset.productKey);
        });
        root.querySelectorAll('.srf__accessory input').forEach((input) => {
          input.checked = true;
        });
        syncSelectionState();
        const resultTitle = recommendedProducts.length >= 3
          ? 'the complete three-bar ritual'
          : recommendedProducts.length === 2
            ? 'a two-bar ritual'
            : recommendedCard?.dataset.productTitle || 'their ritual';
        root.querySelector('[data-result-name]').textContent = dogName();
        root.querySelector('[data-bundle-name]').textContent = `Does ${dogName()}`;
        root.querySelector('[data-result-product]').textContent = resultTitle;
        root.querySelector('[data-summary-name]').textContent = dogName();
        updateSummary();
        root.dispatchEvent(new CustomEvent('sootheory:quiz-completed', {
          bubbles: true,
          detail: {
            dogName: dogName(),
            recommendation,
            recommendedProducts,
            scores: ritual.scores
          }
        }));
      };

      const selectedCards = () => [
        ...root.querySelectorAll('.srf__product input:checked, .srf__accessory input:checked')
      ].map((input) => input.closest('.srf__product, .srf__accessory')).filter(Boolean);

      const updateSummary = () => {
        const bars = [...root.querySelectorAll('.srf__product input:checked')]
          .map((input) => input.closest('.srf__product'))
          .filter(Boolean);
        const accessories = [...root.querySelectorAll('.srf__accessory input:checked')]
          .map((input) => input.closest('.srf__accessory'))
          .filter(Boolean);
        const regularBarSubtotal = bars.reduce((sum, card) => sum + Number(card.dataset.regularPrice || 0), 0);
        const preorderBarSubtotal = bars.reduce((sum, card) => sum + Number(card.dataset.price || 0), 0);
        const regularAccessorySubtotal = accessories.reduce((sum, card) => sum + Number(card.dataset.regularPrice || card.dataset.price || 0), 0);
        const accessorySubtotal = accessories.reduce((sum, card) => sum + Number(card.dataset.price || 0), 0);
        const discountPercent = bars.length >= 3
          ? Number(root.dataset.trioDiscount)
          : bars.length === 2
            ? Number(root.dataset.duoDiscount)
            : 0;
        const preorderSavings = Math.max(regularBarSubtotal - preorderBarSubtotal, 0);
        const discountedBarPrices = new Map();
        bars.forEach((card) => {
          const preorderPrice = Number(card.dataset.price || 0);
          discountedBarPrices.set(card, Math.round(preorderPrice * (100 - discountPercent) / 100));
        });
        const discountedBarSubtotal = [...discountedBarPrices.values()].reduce((sum, price) => sum + price, 0);
        const savings = Math.max(preorderBarSubtotal - discountedBarSubtotal, 0);
        const accessorySavings = Math.max(regularAccessorySubtotal - accessorySubtotal, 0);
        const total = discountedBarSubtotal + accessorySubtotal;
        const setName = bars.length >= 3 ? 'Complete Ritual Set' : bars.length === 2 ? 'Duo Ritual Set' : 'Single Ritual';
        const upgradeMessage = bars.length >= 3
          ? `Best value — 30% first-batch saving plus an extra ${root.dataset.trioDiscount}% on all three bars.`
          : bars.length === 2
            ? `Your 30% first-batch saving is active, plus an extra ${root.dataset.duoDiscount}% for choosing two bars.`
            : `Your 30% first-batch saving is active. Add one more bar for an extra ${root.dataset.duoDiscount}% off.`;
        const mobileSaving = bars.length >= 3
          ? `30% + extra ${root.dataset.trioDiscount}%`
          : bars.length === 2
            ? `30% + extra ${root.dataset.duoDiscount}%`
            : `First batch · 30% off`;

        root.querySelector('[data-set-name]').textContent = setName;
        root.querySelector('[data-upgrade-message]').textContent = upgradeMessage;
        root.querySelector('[data-mobile-label]').textContent = `${bars.length} ${bars.length === 1 ? 'bar' : 'bars'} selected`;
        root.querySelector('[data-mobile-saving]').textContent = mobileSaving;
        root.querySelector('[data-subtotal]').textContent = money(regularBarSubtotal + regularAccessorySubtotal);
        root.querySelector('[data-preorder-savings]').textContent = `−${money(preorderSavings)}`;
        root.querySelector('[data-preorder-savings-row]').hidden = preorderSavings <= 0;
        root.querySelector('[data-savings]').textContent = `−${money(savings)}`;
        root.querySelector('[data-savings-row]').hidden = savings <= 0;
        root.querySelector('[data-multi-bar-label]').textContent = discountPercent > 0
          ? `Multi-bar extra saving · ${discountPercent}%`
          : 'Multi-bar extra saving';
        root.querySelector('[data-accessory-savings]').textContent = `−${money(accessorySavings)}`;
        root.querySelector('[data-accessory-savings-row]').hidden = accessorySavings <= 0;
        root.querySelector('[data-total]').textContent = money(total);

        const list = root.querySelector('[data-summary-items]');
        list.innerHTML = '';
        selectedCards().forEach((card) => {
          const li = document.createElement('li');
          const title = document.createElement('span');
          const price = document.createElement('b');
          title.textContent = card.dataset.productTitle;
          const preorderPrice = Number(card.dataset.price || 0);
          const regularPrice = Number(card.dataset.regularPrice || preorderPrice);
          const displayPrice = card.classList.contains('srf__product')
            ? discountedBarPrices.get(card) ?? preorderPrice
            : preorderPrice;
          price.textContent = regularPrice > displayPrice
            ? `${money(regularPrice)} → ${money(displayPrice)}`
            : money(displayPrice);
          li.append(title, price);
          list.appendChild(li);
        });

        root.querySelectorAll('.srf__offer-levels > span').forEach((level, index) => {
          level.classList.toggle('is-current', index + 1 === Math.min(bars.length, 3));
        });

        root.querySelectorAll('.srf__product').forEach((card) => {
          const priceNode = card.querySelector('[data-bar-display-price]');
          const labelNode = card.querySelector('[data-bar-offer-label]');
          if (!priceNode || !labelNode) return;
          const preorderPrice = Number(card.dataset.price || 0);
          const isSelected = card.querySelector('input')?.checked;
          const displayPrice = isSelected && discountPercent > 0
            ? Math.round(preorderPrice * (100 - discountPercent) / 100)
            : preorderPrice;
          priceNode.textContent = money(displayPrice);
          labelNode.textContent = isSelected && discountPercent > 0
            ? `FIRST BATCH · 30% + EXTRA ${discountPercent}%`
            : 'FIRST BATCH · 30% OFF';
        });
      };

      root.addEventListener('change', (event) => {
        if (event.target.matches('.srf__choice input, .srf__detail-choice input')) {
          event.target.closest('.srf__panel')?.querySelector('[data-choice-error]')?.setAttribute('hidden', '');
        }
        if (event.target.matches('[name="bars"]')) {
          const selected = root.querySelectorAll('[name="bars"]:checked');
          if (!selected.length) {
            event.target.checked = true;
            syncSelectionState();
            return;
          }
        }
        syncSelectionState();
        if (event.target.matches('[name="bars"], [name="accessories"]')) updateSummary();
      });

      root.querySelectorAll('[data-next]').forEach((button) => {
        button.addEventListener('click', () => {
          if (current === 1 && !dogInput.value.trim()) {
            root.querySelector('[data-name-error]').hidden = false;
            dogInput.focus();
            return;
          }
          if (current === 2 && !new FormData(form).get('coat')) {
            root.querySelector('[data-panel="2"] [data-choice-error]').hidden = false;
            return;
          }
          if (current === 3 && !root.querySelector('[name="details"]:checked')) {
            root.querySelector('[data-panel="3"] [data-choice-error]').hidden = false;
            return;
          }
          if (current === 3) setupResults();
          showPanel(Math.min(4, current + 1));
        });
      });

      root.querySelectorAll('[data-back]').forEach((button) => {
        button.addEventListener('click', () => showPanel(Math.max(1, current - 1)));
      });

      root.querySelector('[data-restart]')?.addEventListener('click', () => {
        form.reset();
        root.querySelectorAll('.is-recommended, .is-selected').forEach((el) => {
          el.classList.remove('is-recommended', 'is-selected');
        });
        showPanel(1);
      });

      root.querySelector('[data-view-ritual]')?.addEventListener('click', () => {
        root.querySelector('.srf__summary')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      root.querySelector('[data-add-ritual]')?.addEventListener('click', async (event) => {
        const button = event.currentTarget;
        const error = root.querySelector('[data-cart-error]');
        const selectedBars = [...root.querySelectorAll('.srf__product input:checked')]
          .map((input) => input.closest('.srf__product'))
          .filter(Boolean);
        const selectedAccessories = [...root.querySelectorAll('.srf__accessory input:checked')]
          .map((input) => input.closest('.srf__accessory'))
          .filter(Boolean);

        error.hidden = true;
        if (selectedBars.some((card) => !card.dataset.variantId)) {
          error.textContent = 'Please connect all three product settings in the theme editor before taking pre-orders.';
          error.hidden = false;
          return;
        }

        const items = selectedBars.map((card) => {
          const recommendedSet = recommendedProducts
            .map((key) => root.querySelector(`[data-product-key="${key}"]`)?.dataset.productTitle)
            .filter(Boolean)
            .join(', ');
          const item = {
            id: Number(card.dataset.variantId),
            quantity: 1,
            properties: {
              "Dog's name": dogName(),
              "Best match": root.querySelector(`[data-product-key="${recommendation}"]`)?.dataset.productTitle || recommendation,
              "Quiz-selected ritual": recommendedSet
            }
          };
          return item;
        });

        selectedAccessories.forEach((card) => {
          if (!card.dataset.variantId) return;
          items.push({
            id: Number(card.dataset.variantId),
            quantity: 1,
            properties: { "Added with ritual for": dogName() }
          });
        });

        button.disabled = true;
        const originalText = button.textContent;
        button.textContent = 'ADDING…';
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('We could not add this ritual to the cart. Please check availability and try again.');
          root.dispatchEvent(new CustomEvent('sootheory:ritual-added', {
            bubbles: true,
            detail: { dogName: dogName(), recommendation, recommendedProducts, itemCount: items.length }
          }));
          window.location.href = `${window.Shopify.routes.root}cart`;
        } catch (err) {
          error.textContent = err.message;
          error.hidden = false;
          button.disabled = false;
          button.textContent = originalText;
        }
      });

      root.dispatchEvent(new CustomEvent('sootheory:quiz-ready', { bubbles: true }));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
